import {
  IReservationResponseDto,
  ISpecialPackageDto,
  ISpecialPackageReservationDto,
} from '../model';
import { axiosMod, getPublicApiUrl } from '../utility';

export interface ISpecialPackageApi {
  getActive(): Promise<ISpecialPackageDto[]>;

  getActiveById(id: number): Promise<ISpecialPackageDto>;

  buy(
    id: number,
    item: ISpecialPackageReservationDto
  ): Promise<IReservationResponseDto>;
}

export class SpecialPackageApi implements ISpecialPackageApi {
  private endpointUrl: string;

  constructor() {
    this.endpointUrl = getPublicApiUrl('/special-package');
  }

  async getActive(): Promise<ISpecialPackageDto[]> {
    const response = await axiosMod().get<ISpecialPackageDto[]>(
      `${this.endpointUrl}/active`
    );

    return response.data;
  }

  async getActiveById(id: number): Promise<ISpecialPackageDto> {
    const response = await axiosMod().get<ISpecialPackageDto>(
      `${this.endpointUrl}/active/${id}`
    );

    return response.data;
  }

  async buy(
    id: number,
    item: ISpecialPackageReservationDto
  ): Promise<IReservationResponseDto> {
    const response = await axiosMod().post<IReservationResponseDto>(
      `${this.endpointUrl}/${id}/buy`,
      item
    );

    return response.data;
  }
}

export default SpecialPackageApi;
